import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import TStore from '../../../../../types/store';
import Video from 'twilio-video';

export function useLocalControls(
  participant: Video.RemoteParticipant | null,
  type: 'local' | 'remote',
) {
  const cameraDisabled = useSelector((state: TStore) => state.twilio.cameraDisabled);
  const microphoneDisabled = useSelector((state: TStore) => state.twilio.microphoneDisabled);

  useEffect(() => {
    if (type === 'local' && participant) {
      participant.videoTracks.forEach((publication) => {
        // @ts-ignore
        cameraDisabled ? publication.track.disable() : publication.track.enable();
      });
    }
  }, [cameraDisabled, participant]);

  useEffect(() => {
    if (type === 'local' && participant) {
      participant.audioTracks.forEach((publication) => {
        // @ts-ignore
        microphoneDisabled ? publication.track.disable() : publication.track.enable();
      });
    }
  }, [microphoneDisabled, participant]);
}
